/**
 * Datos fijos del remitente en Relación de Despachos (MDM)
 */
export const MANIFIESTO_REMITENTE = {
  ciudad: 'MEDELLIN-ANTIOQUIA',
  remite: 'MUNDIAL DE MERCANCIAS SAS',
  nit: '900997817-3',
  direccion: 'CALLE 25 A # 43B - 199. MEDELLIN. ANTIOQUIA',
  telefono: '3014017136',
} as const
